import { createStationBreadcrumbItem } from '@app/components/base/stations/StationBreadcrumbLabel';
import { Page } from '@app/components/page/Page';
import { FragmentIcon } from '@app/modules/fragments/components/FragmentIcon';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { useFragment } from '../hooks/useFragment';
import { useFragmentTabs } from '../hooks/useFragmentTabs';
import { FragmentsCloneView } from './clone/FragmentsCloneView';
import { FragmentViewOverflowActions } from './FragmentViewOverflowActions';

/**
 * Fragment view header: breadcrumbs, station-scoped tabs, clone and overflow actions.
 */
export function FragmentsViewHeader() {
  const { fragment, station } = useFragment();
  const { $t } = useIntl();
  const tabs = useFragmentTabs(station);

  return (
    <Page.Header
      title={fragment.title}
      breadcrumbs={
        <Page.Breadcrumbs
          items={[
            {
              icon: <FragmentIcon fontSize="inherit" />,
              content: $t({
                id: 'fragments.listScreen.allFragments',
                defaultMessage: 'Fragmentos',
              }),
            },
            createStationBreadcrumbItem(station, `/fragments/s/${station.slug}`),
          ]}
        />
      }
      tabs={tabs}
      actions={
        <Stack direction="row" spacing={1} alignItems="center">
          <FragmentsCloneView />
          <FragmentViewOverflowActions station={station} />
        </Stack>
      }
    />
  );
}
